<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Situação financeira e patrimonial'"
                        :TipoCliente="'Pessoa Jurídica'" :Sessao="'Dados Financeiros'"
                        :SubSessao="'Situação Financeira e Patrimonial'" />
                    <span>
                        As informações a seguir devem ser compatíveis com seus investimentos e a sua capacidade
                        financeira e patrimonial, conforme definido na regulamentação vigente.
                    </span>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 22%">
                            <label class="label" for="nome">Faturamento médio mensal*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" v-model="localPF.FaturamentoMedioMensal" type="text" id="nome"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('FaturamentoMedioMensal')"
                                @focus="() => focusIn('FaturamentoMedioMensal')"
                                @input="event => handleInput(event, 'FaturamentoMedioMensal')">
                            <p v-if="camposObrigatorios.erroFaturamentoMedioMensal" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 22%">
                            <label class="label" for="nome">Capital social*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" v-model="localPF.CapitalSocial" type="text" id="nome"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('CapitalSocial')"
                                @focus="() => focusIn('CapitalSocial')"
                                @input="event => handleInput(event, 'CapitalSocial')">
                            <p v-if="camposObrigatorios.erroCapitalSocial" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 22%">
                            <label class="label" for="nome" style="height: 20%">Patrimônio em aplicações financeiras</label>
                            <p class="sub-label" for="nome" style="height: 15%"></p>
                            <input class="field" v-model="localPF.PatrimonioAplicacoesFinanceiras" type="text" id="nome"
                                @change="salvarAlteracoesLocalmente"
                                @blur="() => focusOut('PatrimonioAplicacoesFinanceiras')"
                                @focus="() => focusIn('PatrimonioAplicacoesFinanceiras')"
                                @input="event => handleInput(event, 'PatrimonioAplicacoesFinanceiras')">
                            <p v-if="camposObrigatorios.erroPatrimonioAplicacoesFinanceiras" class="erro" style="height: 10%"></p>
                        </div>
                        <div class="label__field" style="width: 22%">
                            <label class="label" for="nome" style="height: 20%">Patrimônio líquido*</label>
                            <p class="sub-label" for="nome" style="height: 15%">(caso não possua, incluir o valor "0")</p>
                            <input class="field" v-model="localPF.PatrimonioLiquido" type="text" id="nome"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('PatrimonioLiquido')"
                                @focus="() => focusIn('PatrimonioLiquido')"
                                @input="event => handleInput(event, 'PatrimonioLiquido')">
                            <p v-if="camposObrigatorios.erroPatrimonioLiquido" class="erro" style="height: 10%">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 29%">
                            <label class="label" for="nome">Valor aproximado de bens móveis e imóveis</label>
                            <input class="field field-full" v-model="localPF.ValorBensMoveisImoveis" type="text" style="width: 75%"
                                id="nome" @change="salvarAlteracoesLocalmente"
                                @blur="() => focusOut('ValorBensMoveisImoveis')"
                                @focus="() => focusIn('ValorBensMoveisImoveis')"
                                @input="event => handleInput(event, 'ValorBensMoveisImoveis')">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="subFooterFormulario"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue';
import { formatCurrency, parseCurrency, handleInput } from '@/utils/formUtils';
export default {
    name: 'CadastroPJ_DadosFinanceiros',
    props: ['informacoesFinanceiras', 'Edicao'],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
    },
    mounted() {
        this.$store.commit('SET_PJ_SALVAR_INFO', false);
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    },
    data() {
        return {
            camposObrigatorios: {
                erroFaturamentoMedioMensal: false,
                erroCapitalSocial: false,
                erroPatrimonioLiquido: false,
            },
            localPF: this.informacoesFinanceiras,
            opcoesDeMoeda: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2
            },
            nomeEmpresa: ''
        }
    },
    methods: {
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                if (this.nomeEmpresa === 'GENIAL') {
                    this.$store.commit('SET_ETAPA_CADASTRO', 5);
                }
                else {
                    this.$store.commit('SET_ETAPA_CADASTRO', 4);
                }
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }           
        },
        salvarInformacoes() {
            this.$store.commit('SET_PJ_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PJ_SALVAR_INFO_FINANCEIRO', this.localPF);
        },
        focusOut(fieldName) {
            const valor = this.localPF[fieldName];
            this.localPF[fieldName] = formatCurrency(valor);
        },
        focusIn(fieldName) {
            const value = this.localPF[fieldName];
            this.localPF[fieldName] = parseCurrency(value) ? parseCurrency(value).replace('.', ',') : '';
        },
        handleInput(event, fieldName) {
            const inputValue = event.target.value;
            this.localPF[fieldName] = handleInput(inputValue);
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroFaturamentoMedioMensal: false,
                erroCapitalSocial: false,
                erroPatrimonioLiquido: false,
            };
            if (!this.localPF.FaturamentoMedioMensal) {                
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroFaturamentoMedioMensal = true;
                    nomeDoCampo = 'Faturamento médio mensal';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.CapitalSocial) {                
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCapitalSocial = true;
                    nomeDoCampo = 'Capital social';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.PatrimonioLiquido) {                
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroPatrimonioLiquido = true;
                    nomeDoCampo = 'Patrimônio líquido';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        }
    }
}
</script>

<!--<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
.formulario {
    width: 100%;
}
.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}
.categoriaAgrupamentoFormulario {
    width: 13%;
    margin-right: 15px;
    font-family: 'Inter', sans-serif;
    /* Fonte Inter */
    span {
        font-weight: 400 !important;
        font-size: 13px;
        color: #667085;
    }
}
.label__field {
    padding-right: 30px;
}
.camposAgrupamentoFormulario {
    width: 90%;
    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }
    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;
        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }
        .field__radio {
            width: 20px;
            height: 20px;
        }
        .fieldInRadio {
            border-radius: 8px;
            /* Raio de borda */
            border: 1px solid #D0D5DD;
            /* Borda */
            padding: 10px 14px;
            /* Preenchimento interno */
            background-color: #F9FAFB;
            /* Cor de fundo */
            width: 55%;
        }
        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }
    select {
        width: 105% !important;
    }
    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
    }
}
.title {
    border-bottom: 1px solid #EAECF0;
    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }
    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
.sub-label {
    font-family: 'Inter', sans-serif;
    font-size: 11px;
    font-style: italic;
    color: #344054;
    display: block;
    margin-top: 1px;
}
</style>-->